var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "69.37mm",
    height: "58.24mm",
    viewBox: "0 0 196.64 165.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.64,1.05C185.44,8.42,176.09,17.87,167,27.59,141.46,55,121,86,101.52,117.81,92,133.41,82.45,149,72.62,165.1c-4.5-4.9-8.82-9.58-13.13-14.28Q30.66,119.41,1.8,88.05c-2.23-2.41-2.62-3.83.19-6,3.81-2.92,7-7.9,11.1-8.87s8.43,3.7,12.6,6C37.1,85.36,48.46,91.68,59.63,98.31,63.25,100.47,65.23,100,68,97c16.18-18,32-36.46,50-52.78a427.84,427.84,0,0,1,56-42.4A10.83,10.83,0,0,1,180.26,0c5.46.1,10.92.07,16.38.08Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.ef336bb0.svg";
export { ForwardRef as ReactComponent };